<!-- 学校-延时课表 -->
<template>
  <div>
    <div
      class="index"
      v-loading="loading"
      v-show="!teacher_detail.show && !student_detail.show"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="学校课表" name="schoolTable"></el-tab-pane>
        <el-tab-pane label="班级课表" name="classTable"></el-tab-pane>
      </el-tabs>
      <div>
        <el-form
          :inline="true"
          :model="queryParams"
          label-width="45px"
          style="padding-top: 20px"
        >
          <el-form-item label="学段">
            <el-select
              v-model="queryParams.period"
              placeholder="请选择"
              class="label"
            >
              <el-option
                v-for="item in periodlList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校">
            <el-select
              v-model="queryParams.schoolId"
              placeholder="请选择"
              class="label"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.org_id"
                :label="item.org_name"
                :value="item.org_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学年学期" label-width="70px">
            <el-select
              v-model="queryParams.semester"
              placeholder="请选择"
              class="label"
              @change="
                (n, o) => {
                  getWeekData(n);
                }
              "
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="校区">
            <el-select
              v-model="queryParams.campusId"
              placeholder="请选择"
              class="label"
              @change="getDataList"
            >
              <el-option
                v-for="item in campusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级">
            <el-select
              v-model="queryParams.gradeId"
              @change="getDataList"
              clearable
              placeholder="请选择"
              class="label"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item v-if="activeName=='classTable'" label="班级">
            <el-select
              v-model="queryParams.gradeId"
               @change="getDataList"
              clearable
              placeholder="请选择"
              class="label"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <br /> -->
          <el-form-item label="课程">
            <el-input
              v-model="queryParams.courseName"
              clearable
              placeholder="请输入"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item v-if="activeName=='classTable'" label="班级" >
            <el-input
              v-model="queryParams.className"
              clearable
              placeholder="请输入"
              style="width: 220px"
            ></el-input>
          </el-form-item > -->
          <el-form-item label="教师" label-width="70px">
            <el-input
              v-model="queryParams.teacherName"
              placeholder="请输入"
              clearable
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="周次" v-if="weekList.length > 0">
            <el-select
              v-model="queryParams.week"
              placeholder="请选择"
              class="label"
              @change="getDataList"
              style="width: 270px"
            >
              <el-option
                v-for="item in weekList"
                :key="item.id + 'week'"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button
              type="primary"
              icon="el-icon-search"
              size="small"
              @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
          <el-form-item label="" style="float: right">
            <el-button type="primary" size="small" @click="downloadBmExcel()"
              >导出课表</el-button
            >
          </el-form-item>
        </el-form>

        <div class="header">
          <div class="header-left">
            <p>{{ schoolName }}第{{ queryParams.week }}周课表</p>
            <div class="btn-box">
              <div
                class="btn-item"
                @click="nextWeekFun(-1)"
                :class="{ no_click: queryParams.week == 1 }"
              >
                <img
                  src="./imgs/left_icon.svg"
                  alt=""
                  style="margin-right: 10px"
                />
                <el-button type="text">上周</el-button>
              </div>
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="nextWeekFun(0)"
                :class="{ no_click: !isWeek || queryParams.week == 1 }"
                >本周</el-button
              >
              <div
                class="btn-item"
                @click="nextWeekFun(1)"
                :class="{ no_click: queryParams.week == lastWeek }"
              >
                <el-button type="text" style="margin-left: 20px"
                  >下周</el-button
                >
                <img
                  src="./imgs/right_icon.svg"
                  alt=""
                  style="margin-left: 10px"
                />
              </div>
            </div>
            <div class="sort">
              <!-- <span>排序:</span>
                        <span>课程数</span> -->
              <!-- <img src="./imgs/sort.svg" alt=""> -->
            </div>
          </div>

          <!-- <el-button style="height:32px" size="small">修改课表</el-button> -->
        </div>
        <!-- 课程表 -->
        <template v-if="tableData && Object.keys(tableData).length">
          <div class="class-table">
            <div class="table-wrapper">
              <div class="table-container">
                <table id="exportOutTable" border="1">
                  <thead>
                    <tr style="background: #f7f7f7">
                      <th class="th-one" colspan="2">
                        <span class="bottom"> 班级/课节 </span>
                        <div class="line"></div>
                        <span class="top">日期 </span>
                      </th>
                      <th v-for="(week, index) in weeks" :key="index">
                        <p>{{ week.value || "" }}</p>
                        <p>{{ week.date || "" }}</p>
                        <!-- {{ week.value + " " }}{{ week.date || "" }} -->
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(it, i) in tableData" :key="i">
                      <td
                        :rowspan="it.courseNamerow"
                        v-if="!it.courseNameshow"
                        style="background: #f7f7f7"
                      >
                        <p class="courseNameClass">{{ it.courseName }}</p>
                      </td>
                      <td>
                        <p>{{ it.courseData }}</p>
                      </td>
                      <td v-for="(day, index) in it.courseList" :key="index">
                        <div class="td-box" v-if="day">
                          <p style="font-weight: bold; color: #000">
                            {{ day.courseName }}
                          </p>
                          <p>
                            <span
                              class="statistical_class"
                              @click="toStatistical(day, 'teacher')"
                              >{{ day.teacherName }}
                              <span v-if="day.extOrgName"
                                >( {{ day.extOrgName }} )
                              </span></span
                            >
                          </p>
                          <!-- <el-tooltip
                                v-if="
                                  day.classTimeName && day.classTimeName.length > 19
                                "
                                class="item"
                                effect="light"
                                :content="'上课时间: ' + day.classTimeName"
                                placement="top-end"
                              >
                                <p class="ellipsis">
                                  上课时间：{{ day.classTimeName }}
                                </p>
                              </el-tooltip>
                              <p
                                class="ellipsis"
                                v-if="
                                  day.classTimeName && day.classTimeName.length < 19
                                "
                              >
                                上课时间：{{ day.classTimeName }}
                              </p> -->
                          <p v-if="day.locationName && day.locationName != ''">
                            上课地点：{{ day.locationName }}
                          </p>
                          <p v-if="day.currentClassNum && day.classNum">
                            当前课时/总课时：{{ day.currentClassNum }}/{{
                              day.classNum
                            }}
                          </p>
                          <p v-if="day.selectedCount && day.totalLimit">
                            报名数/招生数：<span
                              class="statistical_class"
                              @click="toStatistical(day, 'student')"
                              >{{ day.selectedCount }}</span
                            >/{{
                              day.totalLimit != 99999 ? day.totalLimit : "不限"
                            }}
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <img class="no_data" src="@/assets/img/no_data.svg" alt="" />
        </template>
      </div>
    </div>
    <TeacherDetail
      :info="teacher_detail.info"
      v-show="teacher_detail.show"
      @to-index="toIndex"
      :semester="detail_semester"
      :semesterList="semesterList"
      :schoolId="queryParams.schoolId"
    ></TeacherDetail>
    <StudentDetail
      :info="student_detail.info"
      v-show="student_detail.show"
      @to-index="toIndex"
      :semester="detail_semester"
      :semesterList="semesterList"
      :schoolId="queryParams.schoolId"
    ></StudentDetail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import { getOrgList, getOrgInfoList } from "@/api/user/userCenter";
import util from "@/utils/util.js";
import _ from "lodash";
import dayjs from "dayjs";
export default {
  components: {
    TeacherDetail: () => import("./teacher_detail.vue"),
    StudentDetail: () => import("./student_detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        period: "0",
        schoolId: "",
        semester: "",
        campusId: "",
        gradeId: "",
        week: 1,
        teacherName: "",
        courseName: "",
        className: "",
      },
      activeName: "schoolTable",
      schoolName: "",
      lastWeek: 0,
      periodlList: [
        { id: "0", label: "小学" },
        { id: "1", label: "初中" },
        { id: "2", label: "高中" },
        { id: "3", label: "幼儿园" },
        { id: "4", label: "高职" },
        { id: "5", label: "中职" },
        { id: "7", label: "高等教育" },
        { id: "8", label: "特殊教育" },
      ],
      weekData: [],
      weekList: [],
      classList: [],
      schoolList: [],
      campusList: [],
      gradeList: [],
      courseList: [],
      teacherList_1: [
        { id: 1, label: "本校" },
        { id: 2, label: "机构" },
      ],
      teacherList_2: [],
      userList: [],
      semesterList: [],
      teacherList: [],
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      semesterArr: [],
      setting: {
        info: {},
        show: false,
      },
      isWeek: false,
      weeks: [],
      tableShow: false,
      nextWeek: 0,
      todayWeek: {},
      Userlist: JSON.parse(sessionStorage.getItem("userInfo")) || {},
      loading: false,
      detail_semester: "",
      teacher_detail: {
        info: {},
        show: false,
      },
      student_detail: {
        info: {},
        show: false,
      },
    };
  },
  watch: {
    "queryParams.period": function (n, o) {
      // 触发学段
      this.getSchoolList(n);
    },
    "queryParams.schoolId": function (n, o) {
      this.queryParams.gradeId = "";
      this.queryParams.campusId = "";
      this.getParams(n);
      // 触发学校
      this.schoolList.forEach((it) => {
        if (it.org_id == n) {
          this.schoolName = it.org_name;
        }
      });
    },
    "queryParams.campusId": function (n, o) {
      // 触发校区
      this.queryParams.gradeId = "";
      this.gradeList = [];
      this.gradeList =
        this.campusList.filter((v) => v.id === n)[0]?.children || [];
    },
    "queryParams.semester": function (n, o) {
      // 触发学期学年
    },
  },
  created() {
    this.getSchoolList();
  },
  methods: {
    async getSchoolList(type) {
      let params = {
        org_type: "2", //	否	int	（org_type: 1:机构,2:学校,7.班级）
        org_parent_id: sessionStorage.getItem("orgId") || "", //		否	int	上级机构id(查的是直属下级单位)
        //  keyword:"",//		否	string	机构名字模糊搜索
        //  province_code:"",//		否	string	省级code
        //  city_code:"",//		否	string	市级code
        //  area_code:"",//		否	string	区级code
        school_period: type || this.queryParams.period, //		否	int	学段（0小学、1初中、2高中详见文档十三.9）
        //  school_category:"",//		否	int	学校类别（详见文档十三.12）
        //  certification:"",//		否	int	认证(0:未认证,1:已认证)
        //  order_by:"",//		否	int	1是按资源数排序，0默认按访问量排序
        //  page:"",//		否	int	页码
        //  page_size:"",//		否	int	每页条数，默认20，最大50
        //  school_id:"",//		否	string	学校id，显示班级列表
        //  vocational_edu:"",//		否	int	是否查询职教的学校，1：是
        //  flag:"",//		否	int	标记(0:正常,1:演示,2:测试)
        //  platform_code:"",//		否	string	实体平台编码
        //  v_platform_code:"",//		否	string	虚拟平台编码
        //  show_website:"",//		否	int	限定必须开启了机构主页的，1限定，0不限，默认不限(只针对机构、学校有效)
        //  org_parent_ids:"",//		否	int	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
      };

      var { code, result } = await getOrgInfoList(params);
      if (code === "000000") {
        this.schoolList = result.list;
        if (result.list.length > 0) {
          if (
            JSON.parse(sessionStorage.userInfo).user_id ==
            "0683f7b06e0811eca8a8020315d352ba"
          ) {
            this.queryParams.schoolId = "b53e1d76639f11ec85f202031511890c";
            this.schoolName = "实验小学";
          } else {
            this.queryParams.schoolId = this.schoolList[0].org_id;
            this.schoolName = this.schoolList[0].org_name;
          }
        }
      }
      console.log("延时课表-学校列表", result);
    },
    // 通过学校ID查询学年学期、校区、年级
    async getParams(schoolId) {
      let gradeRes = await api.Teacherclass({
        org_id: schoolId,
      });
      if (gradeRes.code === "000000") {
        let gradeResData = gradeRes.result.list || [];
        //  org_type 部门类型(3校区，5学段，6年级，7班级)
        this.classList = [];
        let schoolList = _.groupBy(gradeResData, "org_type")["3"];
        let fieldList = _.groupBy(gradeResData, "org_type")["5"];
        let fieldByPid = _.groupBy(fieldList, "parent_id");
        let gradeList = _.groupBy(gradeResData, "org_type")["6"];
        let gradeByPid = _.groupBy(gradeList, "parent_id");
        let classList = _.groupBy(gradeResData, "org_type")["7"];
        let classByPid = _.groupBy(classList, "parent_id");
        schoolList.forEach((item) => {
          let fieldChild = [];
          if (!fieldByPid[item.org_id]) return;
          fieldByPid[item.org_id].forEach((fieldItem) => {
            if (!gradeByPid[fieldItem.org_id]) return;
            gradeByPid[fieldItem.org_id].forEach((gradeItem) => {
              let classArr = [];
              if (!classByPid[gradeItem.org_id]) return;
              classByPid[gradeItem.org_id].forEach((classItem) => {
                classArr.push({
                  label: classItem.org_name,
                  id: classItem.org_id,
                  combineId: classItem.org_id,
                  children: [],
                });
              });
              fieldChild.push({
                label:
                  gradeItem.org_name.indexOf(fieldItem.org_name) != -1
                    ? gradeItem.org_name
                    : fieldItem.org_name + gradeItem.org_name,
                id: gradeItem.org_id,
                combineId: gradeItem.org_id,
                children: classArr,
              });
            });
          });
          this.classList.push({
            label: item.org_name,
            id: item.org_id,
            combineId: item.org_id,
            children: fieldChild,
          });
        });
        this.campusList = this.classList.slice();
        if (this.campusList.length) {
          this.queryParams.campusId = this.campusList[0].id;
        }
        console.log("学校校区和年级信息", this.classList);
      } else {
        console.log(gradeRes.message);
      }
      // 获取学年学期
      let semesterRes = await api.getSemesterList({
        orgId: schoolId || this.schoolList[0].org_id,
      });
      if (semesterRes.code === "0") {
        console.log("学年学期", semesterRes.data);
        this.semesterArr = semesterRes.data;
        if (this.semesterArr && this.semesterArr.length > 0) {
          this.semesterList = this.semesterArr.map((v) => ({
            label:
              v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
            value: v.schoolYear + "_" + v.semester,
            id: v.id,
            isCurrent: v.isCurrent,
            startDate: v.startDate,
            endDate: v.endDate,
          }));
          let semesterRes = this.semesterList.filter((e) => e.isCurrent);
          this.queryParams.semester = semesterRes[0]?.value;
        }
      }
      this.getWeekData();
    },
    nextWeekFun: _.throttle(
      async function (type) {
        if (
          (this.queryParams.week == 1 && type == -1) ||
          (this.queryParams.week == this.lastWeek && type == 1)
        )
          return false;
        if (type === 0) {
          // 回到本周
          if (this.weekData.length > 0) {
            let nowDate = dayjs(new Date().getTime()).format("YYYY-MM-DD");
            this.weekData.forEach((it) => {
              if (it.semesterDateList && it.semesterDateList.length > 0) {
                it.semesterDateList.forEach((j) => {
                  if (j && j.date && j.date.indexOf(nowDate) != -1) {
                    this.queryParams.week = it.weekNum || 1;
                  }
                });
              }
            });
          } else {
            this.queryParams.week = 1;
          }
        } else {
          this.queryParams.week += type;
        }
        this.getDataList();
      },
      1500,
      { leading: true, trailing: false }
    ),
    async getDataList() {
      this.tableData = [];
      try {
        this.loading = true;
        let _this = this;
        let params = {
          orgId: _this.queryParams.schoolId,
          platformCode: sessionStorage.getItem("platformCode"),
          schoolYearSemester: _this.queryParams.semester, //	学年学期
          campusId: _this.queryParams.campusId, //	校区Id
          weekNum: _this.queryParams.week, //	第几周
          courseType: _this.activeName == "schoolTable" ? "1" : "2", //1-校内社团课 2-作业看管课构
          teacherName: _this.queryParams.teacherName,
          courseName: _this.queryParams.courseName,
          gradeId: _this.queryParams.gradeId,
        };
        if (_this.activeName == "classTable") {
          params.className = _this.queryParams.className;
        }
        let res =
          _this.activeName == "schoolTable"
            ? await api.handleSchoolTimetable(params)
            : await api.handleClassTimetable(params);
        if (res.code === "0") {
          _this.weeks = res.data.weeks;
          for (var k in res.data.timetableMap) {
            if (Object.keys(res.data.timetableMap[k]).length != 0) {
              for (var j in res.data.timetableMap[k]) {
                let classList = [null, null, null, null, null];
                res.data.timetableMap[k][j].forEach((it) => {
                  if (it != null) {
                    classList[it.dayOfWeek - 1] = it;
                  }
                });
                let courseObj = {
                  courseName: k,
                  courseData: j,
                  courseList: classList,
                };
                _this.tableData.push(courseObj);
              }
            }
          }
          _this.combineCell(_this.tableData);
          _this.filterWeeks(_this.weeks);
          _this.detail_semester = _this.queryParams.semester;
        } else {
          _this.tableData = [];
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    combineCell(list) {
      for (let field in list[0]) {
        var k = 0;
        while (k < list.length) {
          list[k][field + "row"] = 1;
          list[k][field + "show"] = false;
          for (var i = k + 1; i <= list.length - 1; i++) {
            if (list[k][field] == list[i][field] && list[k][field] != "") {
              list[k][field + "row"]++;
              list[k][field + "show"] = false;
              list[i][field + "row"] = 1;
              list[i][field + "show"] = true;
            } else {
              break;
            }
          }
          k = i;
        }
      }
      return list;
    },
    // 获取学期周次信息
    async getWeekData(semester) {
      console.log(
        "获取学期周次信息semester",
        semester,
        this.queryParams.semester
      );
      this.weekList = [];
      let res = await api.getWeekInfo({
        orgId: this.queryParams.schoolId || "",
        schoolYearSemester: semester || this.queryParams.semester,
      });
      if (res.code === "0" && res.data.length > 0) {
        this.weekData = res.data;
        //获取最后一周为第几周
        this.lastWeek = res.data[res.data.length - 1].weekNum || 0;
        res.data.forEach((it) => {
          this.weekList.push({
            id: it.weekNum,
            label: `第${it.weekNum}周 (${it.startDate.date.slice(
              0,
              10
            )}至${it.endDate.date.slice(0, 10)})`,
          });
        });
        //判断今天是不是本周次内
        this.isWeek = util.isWeekInData(res.data);
      }
      // 获取本周周次
      this.nextWeekFun(0);
      // this.getDataList();
    },
    //解决接口返回没有日期时进行补充
    filterWeeks(weeks) {
      var oneDayTime = 24 * 60 * 60 * 1000;
      let haveValue = weeks.find((it) => {
        return it.date;
      });
      weeks.forEach((it) => {
        if (!it.date) {
          if (it.key > haveValue.key) {
            it.date = util.timestampToTime(
              new Date(haveValue.date).getTime() +
                oneDayTime * (it.key - haveValue.key)
            );
          } else {
            it.date = util.timestampToTime(
              new Date(haveValue.date).getTime() -
                oneDayTime * (haveValue.key - it.key)
            );
          }
        }
      });
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    toStatistical(item, type) {
      console.log("教师/学生考勤", item);
      if (type === "teacher") {
        this.teacher_detail.info = item;
        this.teacher_detail.show = true;
      } else {
        this.student_detail.info = item;
        this.student_detail.show = true;
      }
    },
    toIndex() {
      this.teacher_detail.show = false;
      this.student_detail.show = false;
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      this.getDataList();
    },
    downloadBmExcel() {
      let vm = this;
      let excelHtml = document.getElementById("exportOutTable")?.outerHTML;
      let html =
        "<html><head><meta charset='utf-8' /></head><body>" +
        excelHtml +
        "</body></html>";
      let blob = new Blob([html], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      let excelTitle = `${vm.schoolName}第${vm.queryParams.week}周课表.docx`;
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, "表格名称.docx");
      } else {
        let a = document.createElement("a");
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = excelTitle;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    width: 100%;
    height: 50px;
    border-radius: 3px;
    background: #eff6ff;
    border: 1px solid #ddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    font-size: 14px;
    .header-left {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        color: #000;
      }
    }
    .btn-box {
      margin-left: 30px;
      display: flex;
      align-items: center;
      .btn-item {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .no_click {
        opacity: 0.3;
        cursor: not-allowed !important;
        button {
          cursor: not-allowed !important;
        }
      }
    }

    .sort {
      margin-left: 30px;
      span {
        margin-right: 20px;
        color: #8b8b8b;
      }
    }
  }
  // Object.keys(item[0]).length
  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }
  ::v-deep .el-tabs__nav {
    height: 42px;
    margin-top: 5px;
  }
  .class-table {
    table,
    table tr th,
    table tr td {
      border: 1px solid #ddd;
      padding: 5px;
    }
    table {
      min-height: 25px;
      line-height: 25px;
      text-align: center;
      border-collapse: collapse;
    }
    .table-wrapper {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
    .table-container {
      table {
        table-layout: fixed;
        width: 100%;

        thead {
          background-color: #fff;
          th {
            font-weight: bold;
            font-size: 14px;
            color: #000;
          }
          .th-one {
            width: 180px;
            height: 50px;
            position: relative;
            .line {
              position: absolute;
              width: 1px;
              height: 197px; /*这里需要自己调整，根据td的宽度和高度*/
              top: 0;
              left: 0;
              background-color: #dddddd;
              transform: rotate(-73.5deg); /*这里需要自己调整，根据线的位置*/
              transform-origin: top;
            }
            .top {
              position: absolute;
              // color: #9b9b9b;
              color: #000;
              right: 20px;
              top: 10px;
            }
            .bottom {
              position: absolute;
              // color: #9b9b9b;
              color: #000;
              left: 20px;
              bottom: 10px;
            }
          }
        }
        tbody {
          td {
            // border: 1px solid #ddd;
            text-align: center;
            color: #555;
          }
        }

        // tr td:first-child {
        //   font-weight: bold;
        //   font-size: 14px;
        //   color: #000;
        //   .period {
        //     font-size: 8px;
        //   }
        // }
      }
      .statistical_class {
        color: #4991e1;
        cursor: pointer;
      }
    }
    .td-box {
      .ellipsis {
        // 省略号
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }

  .no_data {
    margin: 100px 350px;
  }
  .courseNameClass {
    font-weight: bold;
    font-size: 14px;
    color: #000;
    // width: 15px;

    // margin: 0 auto;

    // line-height: 24px;

    // font-size: 14px;

    // word-wrap: break-word;/*英文的时候需要加上这句，自动换行*/
  }
}
</style>
